import api from '~/services/api';
import { ProdutoProps, ProdutoResponseProps } from '../../types';

const getProdutoByCodProduto = async (
  codProduto: string,
  codLoja: number,
): Promise<ProdutoResponseProps> => {
  const { data } = await api.get<ProdutoResponseProps>('/returnprodutos', {
    params: {
      tipo_busca: 0,
      filtro: [{ cod_produto: codProduto }],
      cod_loja: codLoja,
      inativo: true,
    },
  });

  return data;
};

const getProdutoPai = async (
  codAssociado: string,
  codLoja: number,
): Promise<ProdutoProps> => {
  const { data } = await api.get<ProdutoProps>(
    `/produto/busca-pai/${codAssociado}/${codLoja}`,
  );

  return data;
};

export const getInfos = { getProdutoByCodProduto, getProdutoPai };
